import { useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { makeApi } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function AdminOverview() {
  const { getToken } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    makeApi(getToken).get("/admin/overview").then((r) => setData(r.data)).catch(() => {});
  }, [getToken]);

  const stats = [
    { label: "UGC NET subjects seeded", key: "ugc_subjects" },
    { label: "CSIR NET subjects seeded", key: "csir_subjects" },
    { label: "Blueprints", key: "blueprints" },
    { label: "Total users", key: "total_users" },
  ];

  return (
    <div className="space-y-8" data-testid="admin-overview-page">
      <div>
        <div className="flex items-center gap-3">
          <h1 className="font-display font-bold text-2xl sm:text-3xl text-slate-900 tracking-tight">Overview</h1>
          <Badge variant="outline" className="border-slate-200 text-slate-500">{data?.env || "preview"}</Badge>
        </div>
        <p className="text-slate-600 mt-2 text-sm">Platform-wide snapshot. More widgets ship stage by stage.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {stats.map((s) => (
          <Card key={s.key} className="p-6 border-slate-200" data-testid={`admin-stat-${s.key}`}>
            <p className="text-xs uppercase tracking-wider text-slate-500 font-medium">{s.label}</p>
            <p className="font-display font-extrabold text-4xl mt-2 text-slate-900">{data?.[s.key] ?? "—"}</p>
          </Card>
        ))}
      </div>

      <Card className="p-6 border-slate-200">
        <h2 className="font-display font-semibold text-lg">Before launch</h2>
        <ol className="mt-4 space-y-2 text-sm text-slate-700 list-decimal pl-5">
          <li>Verify each active blueprint against the current official bulletin (Blueprints → Verification).</li>
          <li>Build and publish questions for the shared pools and each subject (Question bank; see App health for shortages).</li>
          <li>Record verified official exam dates (Exam dates).</li>
          <li>Add PayU test credentials and run a test-mode payment (Integration settings).</li>
        </ol>
      </Card>
    </div>
  );
}
